import React from 'react'
import { ConciergeWidget } from 'components/Widgets'

export const Concierge: React.FC<React.PWC<unknown>> = () => <ConciergeWidget />
